// 9fbef606107a605d69c0edbcd8029e5d
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { getSessionStorage } from '../../../../../../utils';
import {
  getUserEmail,
  getUserLoggedInState,
  getUserPhoneNumber,
} from '../../../../account/User/container/User.selectors';
import BagPageSelectors from '../../../BagPage/container/BagPage.selectors';
import CheckoutSelector, {
  getLoginV2FlowEnabled,
  getPickupValues,
  isGuest,
  isUsSite,
} from '../../../Checkout/container/Checkout.selector';
import SMSNotificationsSelectors from '../../../Confirmation/organisms/SMSNotifications/container/SMSNotifications.selectors';
import { getContactFormValuesFromSS } from '../../molecules/ContactForm/ContactForm.util';
import PickupAddressForm from '../../molecules/Pickup/views/PickupForm';
import { getShippingFormValuesFromSS } from '../Shipping/Shipping.utils';
import { SPC_SECTION } from '../SinglePageCheckout.constants';
import { getSinglePageCheckoutSectionState } from '../SinglePageCheckout.selector';
import { setPhoneCountryPickUp } from '../../../Checkout/container/Checkout.action';
import { getIsInternationalPhoneNumber } from '../../../../../../reduxStore/selectors/session.selectors';

export const PickupFormContainer = (props) => {
  return <PickupAddressForm {...props} />;
};

const mapStateToProps = (state, { formName }) => {
  const pickupFormInput = state.form[formName]?.values || {};
  const emailSignUpFlags = BagPageSelectors.getIfEmailSignUpDone(state);
  const emailSignUpCaRichText = CheckoutSelector.getEmailSignUpCaRichTextSelector(state);
  const orderHasPickUp = CheckoutSelector.getIsOrderHasPickup(state);
  const isChildrenPalace = SMSNotificationsSelectors.getChildrenPalaceKey(state);
  const isGymboree = SMSNotificationsSelectors.getGymboreeKey(state);
  const isSnJ = SMSNotificationsSelectors.getSNJKey(state);
  const isLoginV2FlowEnabled = getLoginV2FlowEnabled(state);
  const contactData = isLoginV2FlowEnabled
    ? getSinglePageCheckoutSectionState()(state, SPC_SECTION.SHIPPING)
    : getSinglePageCheckoutSectionState()(state, SPC_SECTION.PICKUP);
  const contactSectionValues = getSinglePageCheckoutSectionState()(state, SPC_SECTION.CONTACT);
  const contactFormValuesFromSS = getShippingFormValuesFromSS(contactData);
  const emailAddressFromSS = getContactFormValuesFromSS(contactSectionValues);
  const shippingContactInfo = CheckoutSelector.getShippingContactInfo(state);
  const isLoggedIn = getUserLoggedInState(state);
  const loggedInUser = {
    emailAddress: getUserEmail(state),
    phoneNumber: getUserPhoneNumber(state),
  };
  const pickupValues = getPickupValues(state);
  const savedEmail = CheckoutSelector?.getVenmoUserEmail(state) || emailAddressFromSS?.emailAddress;
  const emailFailSafe = getSessionStorage('emailForFailSafe') || false;
  const venmoStatus = getSessionStorage('isVenmoPayment') || false;
  const isInternationalPhoneNumberEnabled = getIsInternationalPhoneNumber(state);

  return {
    pickupFormInput,
    isGuestUser: isGuest(state),
    isMobile: CheckoutSelector.getIsMobile(),
    smsSignUpLabels: CheckoutSelector.getSmsSignUpLabels(state),
    isUsSite: isUsSite(state),
    emailSignUpFlags,
    emailSignUpCaRichText,
    orderHasPickUp,
    isChildrenPalace,
    isGymboree,
    isSnJ,
    contactFormValuesFromSS,
    shippingContactInfo,
    loggedInUser,
    contactData,
    isLoggedIn,
    pickupValues,
    savedEmail,
    emailFailSafe,
    venmoStatus,
    emailAddressFromSS,
    isInternationalPhoneNumberEnabled,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    dispatchFormFieldChange: (key, value) => dispatch(change('PickupForm', key, value)),
    setPhoneCountryAction: (payload) => dispatch(setPhoneCountryPickUp(payload)),
  };
};

PickupFormContainer.propTypes = {
  shippingFormInput: PropTypes.shape({}).isRequired,
};

PickupFormContainer.defaultProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PickupFormContainer);
